// This file is used to generate horizontal and vertical layouts for nodes

export function updateColumn(cy, extraRequest) {
    if (extraRequest.includes('source')) {
        let newBaseNodeId = extraRequest.replace('source', '')
        let newbaseNode = cy.nodes(`#${newBaseNodeId}`)
        assignNewSourceNodesColumnLevel(cy.nodes(`.${newBaseNodeId}sourceNode`), newbaseNode, `${newBaseNodeId}generatedNode`)
    } else if (extraRequest.includes('generated')) {
        let newBaseNodeId = extraRequest.replace('generated', '')
        let newbaseNode = cy.nodes(`#${newBaseNodeId}`)
        assignNewGeneratedNodesColumnLevel(cy.nodes(`.${newBaseNodeId}generatedNode`), newbaseNode, `${newBaseNodeId}generatedNode`)
    }
}

// The position of compound node is determined by nodes without children
export function alignColumns(cy, index, relativePlacementConstraint, alignmentConstraint, direction) {
    let columnLevel = 'column' + String(index)
    // Add nodes in this column into vertical alignment constraint
    let verticalNodes = []
    cy.nodes(`.${columnLevel}`).forEach(node => {
        // Only get node without child, which determines the position of compound node
        if (node.isChildless()) {
            verticalNodes.push(node.data().id)
        }
    })
    if (verticalNodes.length) {
        alignmentConstraint['vertical'].push(verticalNodes)
    }
    // Add relative constraints for nodes in this vertical constraints
    relativePlacementConstraint = relativePlacementConstraint.concat(alignColumn(cy, verticalNodes))

    // Loop to find neighbor column until it reaches to the end
    let nextLevel = direction == 'right' ? index + 1 : index - 1
    if (cy.nodes('.column'+String(nextLevel)).length) {
        let constraint = alignColumns(cy, nextLevel, relativePlacementConstraint, alignmentConstraint, direction)
        relativePlacementConstraint = constraint.relativePlacementConstraint
        alignmentConstraint = constraint.alignmentConstraint
    }
    return {relativePlacementConstraint: relativePlacementConstraint, alignmentConstraint: alignmentConstraint}
}

/**  The position of compound node is deternmined by child
    Get specific vertical layout constraint for each node in the same column */
export function alignColumn(cy, nodeIds) {
    let constraints = []
    for (let index = 0; index < nodeIds.length - 1; index ++) {
        let topNode = cy.nodes(`#${nodeIds[index]}`)
        let bottomNode = cy.nodes(`#${nodeIds[index+1]}`)

        // Calculate gap from the center to center of a node
        let topNodeHeight = topNode.height()
        let bottomNodeHeight = bottomNode.height()
        let gap = topNodeHeight/2 + 10 + bottomNodeHeight / 2
        // If they are in different compound nodes, we need to add the height of parent's label, gap within the parent
        if ((topNode.parent().data() && bottomNode.parent().data() && (topNode.parent().data().id != bottomNode.parent().data().id))) {
            gap += 50
        } else if ((topNode.parent().data() || bottomNode.parent().data())) {
            gap += 35
        }

        let constraint = {top: nodeIds[index], bottom: nodeIds[index+1], gap: gap}
        constraints.push(constraint)
    }
    return constraints
}


/** Align rows (horizontal position)
    Only need to get one childless node from nodes and one childless node from neighbors to make horizontal constraint */
export function alignRows(cy, index, relativePlacementConstraint, direction) {
    let neighborColumn = direction == 'right' ? index + 1 : index - 1
    let neighbors = cy.nodes(`.column${neighborColumn}`)
    let nodes = cy.nodes(`.column${index}`)
    if (neighbors.length && nodes.length) {
        let constraint = {}
        // This gap is from the center of left node into center of right node
        let gap = getChildlessNode(nodes).width() / 2 + getChildlessNode(neighbors).width() / 2 + 100
        if (direction == 'right') {
            constraint = {
                left: getChildlessNode(nodes).data().id,
                right: getChildlessNode(neighbors).data().id,
                gap: gap
            }
            relativePlacementConstraint.push(constraint)
        } else {
            constraint = {
                left: getChildlessNode(neighbors).data().id,
                right: getChildlessNode(nodes).data().id,
                gap: gap
            }
            relativePlacementConstraint.push(constraint)
        }
        relativePlacementConstraint = alignRows(cy, neighborColumn, relativePlacementConstraint, direction)
    }
    return relativePlacementConstraint
}


// Get one of childless node in the nodes
export function getChildlessNode(nodes) {
    let childlessNode = nodes[nodes.length - 1]
    nodes.forEach(node => {
        if (node.isChildless()) {
            childlessNode = node
        }
    })
    return childlessNode
}

// Assign column class to newly added generated nodes
export function assignNewGeneratedNodesColumnLevel(generatedNodes, baseNode, classification) {
    refreshNodeClass(generatedNodes, classification)
    let generatedColumnLevel = findColumnLevel(baseNode) + 1
    assignColumnLevel(generatedNodes, generatedColumnLevel)
}

// Assign column class to newly added sources nodes
export function assignNewSourceNodesColumnLevel(sourceNodes, baseNode, classification) {
    refreshNodeClass(sourceNodes, classification)
    let sourceColumnLevel = findColumnLevel(baseNode) - 1
    assignColumnLevel(sourceNodes, sourceColumnLevel)
}

// Refresh nodes' generated/source class
// Update node class in order to priotise newly requested data's hierarchy
export function refreshNodeClass(nodes, classification) {
    nodes.forEach(node => {
        if (node.descendants().length) {
            node.descendants().forEach(child => {
                child.classes().forEach(subclass => {
                    if (subclass.includes('Node') || subclass.includes('source')) {
                        child.removeClass(subclass)
                        child.addClass(classification)
                    } else if (subclass.includes('column')) {
                        child.removeClass(subclass)
                    }
                })
            })
        }
    })
}

// Find which column level this node is in
export function findColumnLevel(node) {
    let classes = node.classes()
    let level = null
    classes.forEach(name => {
        if (name.includes('column')) {
            level = parseInt(name.replace('column', ''))
        }
    })
    return level
}

// Assign column level to each node and its descendants
export function assignColumnLevel(nodes, level) {
    let levelClass = 'column' + String(level)
    nodes.addClass(levelClass)
    nodes.descendants().addClass(levelClass)
}
